import React from 'react';
import Layout from '../components/layout/Layout';
import FatLossReportForm from '../components/reports/FatLossReportForm';

const FatLossReportPage = () => {
  return (
    <Layout>
      <FatLossReportForm />
    </Layout>
  );
};

export default FatLossReportPage;
